module.exports = __webpack_public_path__ + "img/7.62c28936.png";